<template>
  <div>
    <!-- FAQ -->
    <div>
      <h3>FAQ</h3>
      <div class="py-5">編輯前請先確認FAQ分類，可自行添加問題</div>
      <!-- itemList -->
      <PageCollapse v-for="(item, i) in support.faq" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">Q{{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(item)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <!-- Basic section -->
          <div>
            <!-- 選擇FAQ分類 -->
            <div class="form-item d-flex py-5">
              <h4 class="w-180px mr-5">選擇FAQ分類</h4>
              <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
                <div class="support-downloads-autocomplete w-248px">
                  <v-autocomplete
                    :items="categories"
                    v-model="item.product_category_id"
                    placeholder="請選擇FAQ分類"
                    item-value="id"
                    item-text="name"
                    outlined
                    dense
                  >
                  </v-autocomplete>
                </div>
                <!--
                <div class="support-downloads-autocomplete w-248px ml-5">
                  <MultiSelectWithCheckbox
                    v-model="item.product_ids"
                    :items="selectCategory(item.product_category_id)"
                    item-value="id"
                    item-text="text"
                  >
                  </MultiSelectWithCheckbox>
                </div>-->
              </div>
            </div>
            <!-- Question -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-180px mr-5">Question</h4>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <v-text-field
                  v-model="item.question"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </label>
            <!-- Answer -->
            <label class="form-item d-flex py-5">
              <h4 class="w-180px mr-5">Answer</h4>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <editor
                  :key="item.id"
                  v-model="item.ans"
                  :plugins="'link image'"
                  :toolbar="'link bold image'"
                />
              </div>
            </label>
          </div>
        </template>
      </PageCollapse>
      <!-- add item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加FAQ</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PageCollapse from '@/components/PageCollapse.vue';
// import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  props: {
    support: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    categories: [],
  }),
  components: {
    PageCollapse,
    // MultiSelectWithCheckbox,
    Editor,
  },
  async created() {
    this.categories = await this.allByBu(this.$route.params.id);
  },
  methods: {
    ...mapActions('category', ['allByBu']),
    addItem() {
      const template = {
        id: null,
        question: '',
        answer: '',
      };
      this.support.faq.push(template);
    },
    deleteItem(item) {
      const index = this.support.faq.map((option) => option.id).indexOf(item.id);
      this.support.faq.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.support.faq.length - 1) {
        this.support.faq.splice(i, 1);
        this.support.faq.unshift(item);
        return;
      }
      // item become next index
      this.support.faq.splice(i, 1);
      this.support.faq.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.support.faq.splice(i, 1);
        this.support.faq.push(item);
        return;
      }
      // item become previous index
      this.support.faq.splice(i, 1);
      this.support.faq.splice(i - 1, 0, item);
    },
    selectCategory(id) {
      const category = this.categories.find((item) => item.id === id);
      if (category) {
        return category.products;
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
.support-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
    font-size: 14px;
  }
}
</style>
